import { EventActions } from '../../store/orm/Event';

export const fetchParcelEvents = ({ match }: any) =>
  EventActions.fetchEvents(match.params.parcelId);
